// import request from '@/utils/requests'
import axios from './http'

export function allUser (token) {
  return axios({
    url: '/api/supplier/allUser',
    headers: {
      'authorization': token,
      'isRuleReview': 1
    },
    method: 'get'
  })
}

export function reviewExcel (token,params){
  return axios({
    method: 'post',
    url: '/api/data-center/report-detail-excel-review',
    responseType: 'blob',
    headers: {
      'authorization': token
    },
    data: params
  })
}

export function putExcel(token,supplierId, params){
  return axios({
    method: 'post',
    url: '/api/data-center/put-extra-excel-review',
    headers: {
      'authorization': token,
      'supplierId' : supplierId,
      'Content-Type':'multipart/form-data'
    },
    data: params
  })
}

export function getPackage (token) {
  return axios({
    url: '/api/package_info/package/getPackage',
    headers: {
      'authorization': token
    },
    method: 'get'
  })
}

